
import Vue from 'vue'
import { DateTime } from 'luxon'
import type { Entry } from '@opendreamnet/ipfs'
import { getIconFromMime } from '~/modules/utils'

export default Vue.extend({
  filters: {
    secsToDateLocale(value?: number) {
      return value ? DateTime.fromSeconds(value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY) : 'Unknown'
    }
  },

  props: {
    entries: {
      type: Array as () => Entry[],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * Returns the icon according to the file type.
     */
    getIcon(mimetype?: string): string {
      return getIconFromMime(mimetype)
    },

    async togglePin(entry: Entry) {
      if (entry.pinned) {
        await entry.unpin()
      } else {
        await entry.pin()
      }
    },

    remove(entry: Entry) {
      // Remove
      this.$accessor.ipfs.rm(entry.relpath)

      // Request reload of entries
      this.$emit('reload')
    }
  }
})
